const OverdueIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" fill="#FEF2F2" />
      <path
        d="M9 16.0127C9 12.1528 12.1401 9.0127 16 9.0127C19.8599 9.0127 23 12.1528 23 16.0127C23 19.7038 20.1265 22.7292 16.5 22.9874V21.9874C19.575 21.7319 22 19.1523 22 16.0127C22 12.7043 19.3086 10.0127 16 10.0127C12.6914 10.0127 10 12.7043 10 16.0127C10 19.1295 12.3894 21.6969 15.4326 21.9839L14.7906 22.9008C11.5062 22.3253 9 19.4594 9 16.0127ZM16.5508 18.3933H15.5508V19.3933H16.5508V18.3933ZM16.5336 11.8138H15.5336V17.182H16.5336V11.8138Z"
        fill="#111113"
      />
    </svg>
  )
}

export default OverdueIcon
